export var mapLegalEntityObject = function (_a) {
    var _b;
    var type = _a.type, data = _a.data;
    return ({
        type: type,
        data: {
            title: data.title,
            inn: data.inn,
            ogrn: (_b = data.ogrn) !== null && _b !== void 0 ? _b : null,
            kpp: data.kpp,
            phone: data.phone,
            address: {
                legal: data.address.legal,
                physical: data.address.physical,
            },
            musicLicenseInvoices: data.musicLicenseInvoices,
        },
    });
};
